import { featuresActive } from 'config/app.config';

export type RemoteConfigurationResponse = {
	_response: any;
	sidebar: RemoteConfigurationItemResponse[];
};

export type RemoteConfigurationItemResponse = {
	key: string;
	value: boolean;
};

const model: types.models.InputModel = {
	_response: ['response', {}],
	sidebar: (model: RemoteConfigurationResponse) => {
		let sidebarConfiguration = {
			billingPaymentTrack: !!featuresActive?.sidebar?.billingPaymentTrack,
			bulkPurchase: !!featuresActive?.sidebar?.bulkPurchase,
			orderTracking: !!featuresActive?.sidebar?.orderTracking,
			prepaidLoyalty: !!featuresActive?.sidebar?.prepaidLoyalty,
		};

		model._response?.sidebar.map((el: RemoteConfigurationItemResponse) => {
			sidebarConfiguration[el?.key] = el?.value;
		});
		return sidebarConfiguration;
	},
};

export default model;
